import { useEffect, useState } from "react";
import { TESTIMONIALS } from "../../data/landingContent";
import DoctorAvatar from "./DoctorAvatar";
import Reveal from "./Reveal";

export default function TestimonialsDaa() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(3);

  useEffect(() => {
    function update() {
      const w = window.innerWidth;
      if (w < 640) setVisible(1);
      else if (w < 980) setVisible(2);
      else setVisible(3);
    }
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  useEffect(() => {
    if (TESTIMONIALS.length <= visible) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % TESTIMONIALS.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [visible]);

  const go = (dir) => {
    setIndex((prev) => (prev + dir + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  const slides = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section className="testimonials-section" id="testimonials" aria-labelledby="testimonials-heading">
      <div className="wrap">
        <Reveal>
          <span className="kicker">Trusted by clinicians</span>
          <h2 className="section-title" id="testimonials-heading">
            Doctors who <b>switched to Deepaarogya</b>
          </h2>
          <p className="section-lede">
            Ortho, ENT, multi-specialty hospitals — practices across India customising the platform to how they work.
          </p>
          <p className="doctors-joining-badge doctors-joining-dark">
            <strong>1,000+</strong> doctors are joining Deepaarogya AI
          </p>
        </Reveal>

        <div className="testimonials-carousel">
          <div
            className="testimonials-track"
            style={{ transform: `translateX(-${(index * 100) / visible}%)` }}
          >
            {slides.map((item, i) => (
              <article
                className="testimonial-card testimonial-card-compact"
                key={`${item.name}-${i}`}
                style={{ flex: `0 0 calc(100% / ${visible})` }}
              >
                <div className="testimonial-stars" aria-hidden="true">★★★★★</div>
                <p className="testimonial-text">{item.text}</p>
                <div className="testimonial-author">
                  <DoctorAvatar name={item.name} img={item.img} size={44} />
                  <div>
                    <strong>{item.name}</strong>
                    <span>{item.role}</span>
                    <span className="testimonial-hospital">{item.hospital}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {TESTIMONIALS.length > visible && (
            <>
              <button type="button" className="testimonial-arrow prev" onClick={() => go(-1)} aria-label="Previous testimonial">
                ‹
              </button>
              <button type="button" className="testimonial-arrow next" onClick={() => go(1)} aria-label="Next testimonial">
                ›
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
